module.exports = __webpack_public_path__ + "0e1b43c9a9baadcee6c24b06ae72f2f8.png";